const PERSISTED_LOGIN_KEY = 'mds_persisted_login_v1';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isTeacherOrStudentRole(role) {
  const r = String(role || '').toLowerCase();
  return r === 'teacher' || r === 'student';
}

export function savePersistedLogin(userData, ttlMs = ONE_WEEK_MS) {
  if (!userData) return;
  if (!isTeacherOrStudentRole(userData.role)) return;

  const payload = {
    version: 1,
    expiresAt: Date.now() + ttlMs,
    userData,
  };

  try {
    localStorage.setItem(PERSISTED_LOGIN_KEY, JSON.stringify(payload));
  } catch (e) {
    // Ignore storage failures (private mode / quota / disabled)
  }
}

export function loadPersistedLogin() {
  try {
    const raw = localStorage.getItem(PERSISTED_LOGIN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    const expiresAt = Number(parsed?.expiresAt || 0);
    const userData = parsed?.userData || null;

    if (!expiresAt || Date.now() > expiresAt) {
      clearPersistedLogin();
      return null;
    }

    if (!userData || !isTeacherOrStudentRole(userData.role)) {
      // Only teachers/students can use persisted login
      clearPersistedLogin();
      return null;
    }

    return { expiresAt, userData };
  } catch (e) {
    clearPersistedLogin();
    return null;
  }
}

export function clearPersistedLogin() {
  try {
    localStorage.removeItem(PERSISTED_LOGIN_KEY);
  } catch {
    // ignore
  }
}

export function hydrateSessionFromPersistedLogin() {
  const existing = sessionStorage.getItem('currentUser');
  if (existing) return { didHydrate: false, userData: null };

  const saved = loadPersistedLogin();
  if (!saved?.userData) return { didHydrate: false, userData: null };

  try {
    const userStr = JSON.stringify(saved.userData);
    sessionStorage.setItem('currentUser', userStr);
    return { didHydrate: true, userData: saved.userData };
  } catch {
    return { didHydrate: false, userData: null };
  }
}


